import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m21.06 11.82-.16-.22q-.42-.51-.99-.81c-.51-.29-1.09-.44-1.69-.44H5.77c-.6 0-1.17.15-1.69.44-.39.21-.74.5-1.03.86-.57.73-.84 1.63-.75 2.53l.37 4.67c.13 1.41.3 3.15 3.47 3.15h11.72c3.17 0 3.33-1.74 3.47-3.16l.37-4.65c.09-.84-.13-1.68-.64-2.37m-6.67 5.52H9.6c-.39 0-.7-.32-.7-.7s.31-.7.7-.7h4.79c.39 0 .7.32.7.7 0 .39-.31.7-.7.7M20.561 8.596c.038.383-.378.64-.742.517a5 5 0 0 0-1.59-.253H5.77c-.556 0-1.104.09-1.616.262-.36.121-.773-.127-.773-.507V6.66C3.38 3.09 4.47 2 8.04 2h1.18c1.43 0 1.88.46 2.46 1.21l1.2 1.6c.25.34.26.36.7.36h2.38c3.126 0 4.347.837 4.601 3.426" }, null, -1)
  ]))]))
}
export default { render: render }